import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { PQRForm } from "@/features/pqr/components/PQRForm";
import type { PqrSubmissionDraft } from "@/features/pqr/pqr.types";

type PQRFormDialogProps = {
  defaultValues?: Partial<PqrSubmissionDraft>;
  isAuthenticated: boolean;
  onOpenChange: (open: boolean) => void;
  open: boolean;
};

export function PQRFormDialog({
  defaultValues,
  isAuthenticated,
  onOpenChange,
  open,
}: PQRFormDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent className="max-h-[90vh] w-[min(94vw,68rem)] gap-0 overflow-hidden border-[#eadcc7] bg-[#f5f1e8] p-0 shadow-[0_28px_90px_-36px_rgba(56,40,22,0.28)] backdrop-blur-none">
        <DialogHeader className="border-b border-ink/10 px-8 pb-6 pt-8 pr-16">
          <DialogTitle>{t("pqr.dialog.title")}</DialogTitle>
          <DialogDescription className="max-w-4xl text-base leading-7">
            {t("pqr.dialog.description")}
          </DialogDescription>
        </DialogHeader>
        <div className="min-h-0 overflow-y-auto px-8 py-8">
          <PQRForm defaultValues={defaultValues} isAuthenticated={isAuthenticated} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
